module.exports = __webpack_public_path__ + "assets/icon-globe.e959087b.svg";